module.exports = __webpack_public_path__ + "static/media/Lens-NS_HK.ef3122dd.png";